import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { checkoutUrl, heroImage, included, price, regularPrice } from '../data/copy';
const assurances = ['Safe, encrypted payment', 'Instant access', '7-day guarantee'];
const delivery = [{
  label: 'Format',
  value: 'Print it, project it, or load it into your LMS.'
}, {
  label: 'Devices',
  value: 'Any device. Nothing to install or update.'
}, {
  label: 'Access',
  value: 'One payment. No expiration.'
}];
export function OfferSection() {
  return <section id="offer" className="defer-paint w-full scroll-mt-6 bg-indigo-deep py-11 sm:py-14" aria-labelledby="offer-heading" data-id="element-136" data-mp="re68emru821u">
      <div className="mx-auto max-w-5xl px-6" data-id="element-137" data-mp="wby65xf5yidy">
        <CountdownTimer data-id="element-138" data-mp="wan35ztjlenw" />

        <div className="mx-auto mt-9 max-w-2xl text-center" data-id="element-139" data-mp="2t5sz0n7thuxs">
          <p className="eyebrow text-gold-soft" data-id="element-140" data-mp="2t7dtkcu4tdvn">Your complete offer today</p>
          <h2 id="offer-heading" className="mt-4 font-display text-[2rem] leading-[1.12] text-ivory sm:text-4xl" data-id="element-141" data-mp="2y4w58azja77c">
            Everything you need to teach art with confidence
          </h2>
        </div>

        <div className="mt-7 grid gap-8 rounded-4xl bg-shell p-6 shadow-lift sm:p-9 lg:grid-cols-[0.95fr_1.05fr] lg:gap-10" data-id="element-142" data-mp="xvh2w4xwov63">
          <div className="flex flex-col" data-id="element-143" data-mp="svcoqlkh0cj1">
            <div className="rounded-3xl bg-sand p-5 sm:p-7" data-id="element-144" data-mp="ox559iymgx45">
              <img src={heroImage} alt="Everything included: six master volumes, six bonus booklets and printable visual resources." className="mx-auto w-full max-w-sm" width={1232} height={1232} sizes="384px" loading="lazy" decoding="async" data-id="element-145" data-mp="1lme2qjcfg20z" />
            </div>

            <div className="mt-6 rounded-3xl border border-gold/40 bg-gold-soft/40 px-6 py-7 text-center" data-id="element-146" data-mp="1ck4y2a3ub2vi">
              <p className="font-sans text-[0.8rem] uppercase tracking-[0.14em] text-stone" data-id="element-147" data-mp="17mbnl4vi7mpf">
                Regular price:{' '}
                <span className="line-through" data-id="element-148" data-mp="3scu629zvdhw1">{regularPrice}</span>
              </p>
              <p className="mt-2 font-display text-[3.5rem] leading-none text-ink" data-id="element-149" data-mp="3sf6sazcnueew">
                {price}
              </p>
              <p className="mt-2 font-sans text-xs uppercase tracking-[0.16em] text-gold-ink" data-id="element-150" data-mp="2o85hjjh3k65">
                Pay once · use forever
              </p>
            </div>

            <CtaButton href={checkoutUrl} size="large" className="mt-5 w-full" data-id="element-151" data-mp="3kvnrrf7di2ik">
              Get the complete system now
            </CtaButton>

            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-152" data-mp="3b2gr27nkvaot">
              {assurances.map(item => <li key={item} className="flex items-center gap-1.5 font-sans text-[11px] text-stone" data-id="element-153" data-mp="3fvt21ezc3iz3">
                  <CheckIcon className="h-3.5 w-3.5 text-terracotta" strokeWidth={2.4} aria-hidden="true" data-id="element-154" data-mp="316wynv882u4t" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-155" data-mp="2s5ypyzmu9yfw">
            <p className="eyebrow text-terracotta-deep" data-id="element-156" data-mp="2s55pggeh4567">Everything included</p>
            <ul className="mt-6 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-157" data-mp="2x2p7zsi7f43y">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 font-sans text-[0.9rem] leading-relaxed text-ink/85" data-id="element-158" data-mp="2dizzb6vt3828">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-terracotta" strokeWidth={2.4} aria-hidden="true" data-id="element-159" data-mp="28kf2zijod8j2" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 rounded-3xl bg-sand px-6 py-6" data-id="element-160" data-mp="2ig8mjlvta2ac">
              <h3 className="font-display text-lg leading-snug text-ink" data-id="element-161" data-mp="2wg9l2uolsxmn">
                Delivered as the moment you buy.
              </h3>
              <dl className="mt-5 space-y-3" data-id="element-162" data-mp="2rh6qk46929sx">
                {delivery.map(item => <div key={item.label} className="flex items-baseline gap-3" data-id="element-163" data-mp="365b30qeplp39">
                    <dt className="w-20 shrink-0 font-sans text-[10px] font-semibold uppercase tracking-[0.16em] text-terracotta-deep" data-id="element-164" data-mp="3179l48t0rvtd">
                      {item.label}
                    </dt>
                    <dd className="font-sans text-[0.85rem] leading-snug text-stone" data-id="element-165" data-mp="3a8z9t6viogng">
                      {item.value}
                    </dd>
                  </div>)}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </section>;
}